import { Lang, i18n } from '../../../utils';
import en from './en.json';
import ru from './ru.json';
var COMPONENT = 'error-message';
i18n.registerKeyset(Lang.En, COMPONENT, en);
i18n.registerKeyset(Lang.Ru, COMPONENT, ru);
export default i18n.keyset(COMPONENT);
// #sourceMappingURL=index.js.map